import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WidgetModule } from 'src/app/widget/widget.module';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-post',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule, WidgetModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss']
})
export class PostComponent implements OnInit {

  posts: string[] = ['com1', 'com1', 'com1', 'com1', 'com1', 'com1',]
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;

  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false
  }

  constructor(
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
  }

  clearInput = new UntypedFormControl();

  clearData() {
    // this.businessData = true;
    this.clearInput.reset();
    //console.log('cleare Data')
  }

  openPostSearch(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }

  close(){
    //console.log('close Model')
    this.bsModalRef.hide()
  }
}


